import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ContainerWrapper } from '../container_wrapper';

import { MagnifierIcon } from './common/magnifier_icon';
import { HigherExcessNotice } from './common/higher_excess_notice';
import { FiltersChangesNotice } from './common/filters_changes_notice';
import { withAvailableQuotes } from '../products/common/with_available_quotes';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    }
}));

const _EmptyStateConditional = ({ isHideHighExcess, availableQuotesSize, padding }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    return (
        availableQuotesSize === 0 && (
            <ContainerWrapper padding={padding} className="test-emptyState-conditional">
                <div className={classes.container}>
                    <MagnifierIcon />
                    {
                        isHideHighExcess ? <HigherExcessNotice /> : <FiltersChangesNotice />
                    }
                </div>
            </ContainerWrapper>
        )
    );
};

_EmptyStateConditional.propTypes = {
    availableQuotesSize: PropTypes.number,
    isHideHighExcess: PropTypes.bool,
    padding: PropTypes.array
};

const mapStateToProps = (state) => {
    const isHideHighExcess = state.getIn(['page', 'isHideHighExcess']);
    return {
        isHideHighExcess
    };
};

const EmptyStateConditional = withAvailableQuotes(connect(mapStateToProps)(_EmptyStateConditional));

export { EmptyStateConditional };
